import React from 'react'
import Icon from 'material-ui/Icon'
import { connect } from 'react-redux'
import * as auth from '../actions/auth'
import { isNil } from 'lodash'
import Divider from 'material-ui/Divider'
import { Link } from 'react-router-dom'
import List, {
  ListItemText,
  ListItem,
  ListItemSecondaryAction,
  ListSubheader,
  ListItemIcon,
} from 'material-ui/List'
import ThemeSwitcher from './ThemeSwitcher'
import history from '../utils/history'
import { withStyles } from 'material-ui/styles'
import classNames from 'classnames'
import * as selectors from 'selectors'
import * as configActions from 'actions/config'

const styles = theme => ({
  active: {},
})

class Navigation extends React.Component {
  onItemClick = item => {
    if (item.action) {
      item.action()
    }
    this.props.toggleSidebar()
  }
  render() {
    const {
      classes,
      logout,
      isAuthentified,
      isAdmin,
      mainCurrency,
      openMainCurrencySelector,
    } = this.props
    const menuItems = [
      {
        title: 'Dashboard',
        link: '/',
        icon: 'donut_large',
      },
      {
        title: 'Funds',
        link: '/funds',
        icon: 'attach_money',
      },
      {
        title: 'Status',
        link: '/status',
        icon: 'build',
        condition: isAdmin,
      },
      {
        title: 'Login / Subscribe',
        link: '/login',
        condition: !isAuthentified,
      },
      {
        title: 'Logout',
        action: logout,
        icon: 'exit_to_app',
        condition: isAuthentified,
      },
      {
        title: 'About',
        link: '/about',
        icon: 'info',
      },
    ].filter(i => isNil(i.condition) || i.condition)
    return (
      <List subheader={<ListSubheader>Menu</ListSubheader>}>
        {menuItems.map(i => (
          <ListItem
            key={i.title}
            button
            component={i.link && Link}
            to={i.link}
            className={classNames({
              [classes.active]: history.location.pathname === i.link,
            })}
            disabled={i.disabled}
            onClick={e => {
              this.onItemClick(i)
            }}
          >
            <ListItemIcon>
              <Icon>{i.icon}</Icon>
            </ListItemIcon>
            <ListItemText primary={i.title} />
          </ListItem>
        ))}
        <Divider />
        <ListItem button onClick={openMainCurrencySelector}>
          <ListItemText primary="Main currency" secondary={mainCurrency} />
        </ListItem>
        <ListItem>
          <ListItemText primary="Dark mode" />
          <ListItemSecondaryAction>
            <ThemeSwitcher />
          </ListItemSecondaryAction>
        </ListItem>
      </List>
    )
  }
}

const mapStateToProps = state => ({
  isAuthentified: selectors.isAuthentified(state),
  isAdmin: selectors.isAdmin(state),
  mainCurrency: selectors.mainCurrency(state),
})

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(auth.logout()),
  toggleSidebar: () => dispatch(configActions.toggleSidebar()),
  openMainCurrencySelector: () =>
    dispatch(configActions.openMainCurrencySelector()),
})

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(Navigation)
)



// WEBPACK FOOTER //
// ./src/components/Navigation.js